import cn from 'classnames';
import React, { memo } from 'react';

import type IProduct from '@sravni/vitrina/lib/types/IProduct';
import { Tooltip } from '@sravni/vitrina-components';


import type IGroupDetailRow from '@components/RatingTable/components/ProductPopup/interfaces/IGroupDetailRow';

import style from './style.module.scss';

interface IRowProps {
  className?: string;
  row: IGroupDetailRow;
  product?: IProduct;
}

const Row: React.FC<IRowProps> = memo(({ className, row, product }) =>
  row.value.value ? (
    <div className={cn(className, style.row)}>
      <div>
        {row.labels.map((label) => (
          <div key={label.value} className={style.labelContainer}>
            <span className={`${style.title} ${style.titleGroupItem}`}>{label.value}</span>
            {label.tooltip && (
              <span className={style.tooltip}>
                <Tooltip product={product} tooltipData={label.tooltip} />
              </span>
            )}
          </div>
        ))}
      </div>
      <div className={style.valueBlock}>
        <span>
          {row.value.value}
          {row.value.tooltip && (
            <span className={style.tooltip}>
              <Tooltip product={product} tooltipData={row.value.tooltip} />
            </span>
          )}
        </span>
      </div>
    </div>
  ) : null,
);

export default Row;
